import { createAsyncThunk } from '@reduxjs/toolkit';
import allocationsBookingApiService from 'api/allocationBookingApiService';
import { ApiError, notifyUser } from 'shared/errorHandling/ErrorToast/errorHandling';
import { AppDispatch, RootState } from 'store';
import { addKeyToReactItem } from 'store/mappers/sharedMapper';
import { DispatchError } from 'store/slices/authSlice';
import { AllocationsAddBookingDto } from 'types/allocation/dto/allocationAddBookingDto/AllocationsAddBookingDto';
import AllocationsAddBookingFormDto from 'types/allocation/dto/allocationAddBookingDto/AllocationsAddBookingFormDto';
import AllocationsAction from 'types/allocation/enums/Allocations';

const updateBooking = createAsyncThunk<
  AllocationsAddBookingDto,
  { data: AllocationsAddBookingFormDto; force: boolean },
  {
    dispatch: AppDispatch;
    state: RootState;
    rejectValue: DispatchError | ApiError;
  }
>(AllocationsAction.UPDATE_BOOKING, async ({ data, force }, { rejectWithValue }) => {
  try {
    const response = await allocationsBookingApiService.updateBooking(data, force);
    if (!response) notifyUser();
    return addKeyToReactItem(response);
  } catch (err) {
    if (err instanceof ApiError) return rejectWithValue(err);

    throw err;
  }
});

export default updateBooking;
